import { Outlet, Navigate } from 'react-router-dom'

export function RootGuard() {
  const isAuthenticated = localStorage.getItem('isAuthenticated')

  // Base domain + logged in → app
  if (isAuthenticated) {
    return <Navigate to="/app/home/welcome" replace />
  }

  // if none above → marketing
  return <Outlet />
}
